import { useFormatting } from 'composables/useFormatting.js'

const {
  diableAllDatesAfterXDays,
  total_hours: _total_hours,
  generateAndDownloadCSV,
  titleizeString,
  generateRandomString,
  beginningOfMonthFromMonthNumber,
  isPresent,
  copyTextToClipboard,
  strDatetoObject,
  dateObjectToFormattedStr,
  DaysFromNowOn,
  formattedHour,
  toHours,
} = useFormatting()

export default {
  data() {
    return { diableAllDatesAfterXDays }
  },
  methods: {
    generateAndDownloadCSV,
    titleizeString,
    generateRandomString,
    beginningOfMonthFromMonthNumber,
    isPresent,
    copyTextToClipboard,
    strDatetoObject,
    dateObjectToFormattedStr,
    DaysFromNowOn,
    formattedHour,
    toHours,
  },
  computed: {
    total_hours() { return _total_hours },
  },
}
